import { AMOUNT_FORMAT_TYPES } from '@ezugi/constants';

export const SPECIFIC_FORMATTING_LIMITS_VALUE = {
  LOW: 1000,
  HIGH: 100000,
};

export const MAX_DIGITS_WITH_ZERO_DECIMALS = 3;

const amountIsBetweenInterval = (amount: number) => (
  amount >= SPECIFIC_FORMATTING_LIMITS_VALUE.LOW && amount < SPECIFIC_FORMATTING_LIMITS_VALUE.HIGH
);

export const setSpecificAmountFormatTypes = (amount: number) => {
  if (!amountIsBetweenInterval(amount)) {
    return AMOUNT_FORMAT_TYPES.EXTEND_LETTER;
  }

  return AMOUNT_FORMAT_TYPES.COMMA;
};

function formatValueWithoutDecimals(amount: string) {
  const [ stringBeforePoint, stringAfterPoint ] = amount.split('.');

  if (stringAfterPoint) {
    const emptyStringIndex = stringAfterPoint.indexOf(' ');

    if (emptyStringIndex !== -1) {
      return `${stringBeforePoint} ${stringAfterPoint.slice(emptyStringIndex + 1)}`;
    }

    return `${stringBeforePoint}`;
  }

  return amount;
}

export const formatForPortrait = (amount: number, formattedAmount: string) => {
  if (!amountIsBetweenInterval(amount)) {
    return `${formattedAmount}`;
  }

  return `${formatValueWithoutDecimals(formattedAmount)}`;
};

export const displayAmount = (isPortraitSpecificFormatting: boolean, amount: number, formattedAmount: string) => {
  if (!isPortraitSpecificFormatting) {
    return `${formattedAmount}`;
  }

  return `${formatForPortrait(amount, formattedAmount)}`;
};

function addZeroDecimals(formattedAmount: string) {
  const regexNr = /\d+(\.\d+)?/;

  const regexRes = formattedAmount.match(regexNr);

  if (regexRes === null) {
    return formattedAmount;
  }

  const numberPart = regexRes[0];
  const [ integerPart, decimalPart ] = numberPart.split('.');

  if (decimalPart) {
    return formattedAmount;
  }

  return formattedAmount.replace(regexNr, `${integerPart}.00`);
}

export const displayBalance = (amount: number, formattedAmount: string) => {
  const maxNrWithZeroDecimals = 10 ** MAX_DIGITS_WITH_ZERO_DECIMALS - 1;
  if (amount > maxNrWithZeroDecimals) {
    return `${formattedAmount}`;
  }
  return `${addZeroDecimals(formattedAmount)}`;
};
